import React, { useState } from 'react'

const Question = ({ question, children }) => {
    const [openAnimation, setOpenAnimation] = useState(false)


    return (
        <div>
            <div className='px-8 py-6 border-t-[#E4E4E7] border-t-[1px] flex justify-between text-left cursor-pointer z-10' onClick={() => { setOpenAnimation(!openAnimation) }}>
                <p className='font-bold text-lg md:text-xl'>{question}</p>
                <p className='font-bold text-lg md:text-xl'>{openAnimation ? '-' : '+'}</p>
            </div>
            <div className={`${openAnimation ? 'faq-fadein' : 'faq-fadeout'} text-left`}
                onAnimationEnd={(e) => {
                    // End on Open Animation
                    if (openAnimation){
                        e.target.classList.add('block')
                    } else {
                        e.target.classList.add('hidden')
                    }
                 }}>
                <p className={`pointer-events-none px-8 pb-16 text-base text-justify text-[#71717A]`}>{children}</p>
            </div>
        </div>
    )
}

export default Question